export const settings = {
	payrollHoursSheetName: "Payroll - Hours",
	payrollPaySheetName: "Payroll - Pay",
	payrollSuffix: " - Payroll",
	timesheetSheetName: "All Employees",
};
